var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'backbone', 'core', 'app-common/template/comments/single-conversation.htm', 'app-common/component/commenting', 'common/component/date-formatter', 'app-common/component/api-call', 'app-common/component/service-call', 'component/bookkeeper-notifications', 'common/lib/md5', 'common/lib/jquery.hotkeys'], function($, _, Backbone, core, singleConversationTemplate, Commenting, dateFormatter, apiCall, serviceCall, BookkeeperNotifications, md5) {
  var SingleConversationView;
  return SingleConversationView = (function(_super) {

    __extends(SingleConversationView, _super);

    function SingleConversationView() {
      SingleConversationView.__super__.constructor.apply(this, arguments);
    }

    SingleConversationView.prototype.className = 'comments-container';

    SingleConversationView.prototype.events = {
      'submit #message-form': 'postToSingleConversation',
      'click .comments-display__edit-toggle': 'toggleEdit',
      'click .comments-display__save-edit button': 'toggleEdit',
      'click .comments-display__exit-edit': 'toggleEdit',
      'click .comments-display__mark-as-read': 'removeBKNotificationEvents',
      'focus [name="reply-input"]': 'showSubmit',
      'blur [name="reply-input"]': 'hideSubmit',
      'mousedown .btn-reply': 'preventHideSubmit'
    };

    SingleConversationView.prototype.inputSelector = '[name="reply-input"]';

    SingleConversationView.prototype.$reminder = function() {
      return $('.comments-display__reminder');
    };

    SingleConversationView.prototype.slideDuration = 200;

    SingleConversationView.prototype.hideSubmitGuard = false;

    SingleConversationView.prototype.bkEvents = [];

    SingleConversationView.prototype.conversationIds = [];

    SingleConversationView.prototype.hideSubmit = function(e) {
      if (this.hideSubmitGuard) {
        this.$el.find(this.inputSelector).focus();
        this.hideSubmitGuard = false;
      } else {
        this.$reminder().removeClass('active');
        SingleConversationView.__super__.hideSubmit.call(this, e);
      }
      return true;
    };

    SingleConversationView.prototype.showSubmit = function() {
      this.$reminder().addClass('active');
      return SingleConversationView.__super__.showSubmit.apply(this, arguments);
    };

    SingleConversationView.prototype.preventHideSubmit = function(e) {
      this.hideSubmitGuard = e.target !== (this.$el.find(this.inputSelector))[0];
      return true;
    };

    SingleConversationView.prototype.initialize = function(conversationIds, replyPlaceholderText, userId) {
      this.conversationIds = conversationIds;
      this.replyPlaceholderText = replyPlaceholderText;
      this.userId = userId != null ? userId : core.getCurrentClientId();
      this.attachedId = this.userId + "-" + _.last(this.conversationIds);
      this.initHotkeys();
      return this.bookkeeperNotifications = new BookkeeperNotifications(_.last(this.conversationIds));
    };

    SingleConversationView.prototype.initHotkeys = function() {
      var _this = this;
      return $(this.el).off('keydown').on('keydown', this.inputSelector, 'ctrl+return', function(e) {
        e.preventDefault();
        return $(e.currentTarget).closest("form").submit();
      });
    };

    SingleConversationView.prototype.setElement = function() {
      SingleConversationView.__super__.setElement.apply(this, arguments);
      return this.initHotkeys();
    };

    SingleConversationView.prototype.render = function() {
      if (this.conversationIds.length < 2) {
        this.renderSingleConversation();
      } else {
        this.renderMergedConversation();
      }
      return this;
    };

    SingleConversationView.prototype.renderSingleConversation = function() {
      var promise,
        _this = this;
      promise = $.when(apiCall('comments', 'single/' + this.attachedId), this.bookkeeperNotifications.getEvents(this.userId, this.conversationIds));
      return promise.done(function(coversationArg, bkEventsArg) {
        var bkEvents, bkEventsBody, conversation, coversationBody, _ref, _ref1, _ref2;
        coversationBody = coversationArg != null ? coversationArg[0] : void 0;
        bkEventsBody = bkEventsArg != null ? bkEventsArg[0] : void 0;
        _this.id = coversationBody != null ? coversationBody.id : void 0;
        conversation = _this.formatUrls(coversationBody != null ? coversationBody.comments : void 0);
        if ((bkEvents = (bkEventsBody != null ? (_ref = bkEventsBody[0]) != null ? (_ref1 = _ref.events) != null ? _ref1.full : void 0 : void 0 : void 0) || [])) {
          _this.serializeBKTransactionEvents(bkEvents);
        }
        return _this.$el.html(_.template(singleConversationTemplate, {
          attachedId: _this.attachedId,
          id: coversationBody != null ? (_ref2 = coversationBody[0]) != null ? _ref2.id : void 0 : void 0,
          conversation: conversation,
          timeAgo: dateFormatter.timeAgo,
          placeholderText: _this.replyPlaceholderText,
          hex_md5: md5["default"].hex_md5,
          allowedToEdit: _this.allowedToEdit,
          bkEvents: _this.bkEvents
        }));
      });
    };

    SingleConversationView.prototype.renderMergedConversation = function() {
      var promise,
        _this = this;
      promise = $.when(apiCall('comments', 'single/' + this.userId + "-" + this.conversationIds[0]), apiCall('comments', 'single/' + this.userId + "-" + this.conversationIds[1]), this.bookkeeperNotifications.getEvents(this.userId, this.conversationIds));
      return promise.done(function(coversationArg1, coversationArg2, bkEventsArg) {
        var bkEvents, bkEventsBody, conversation, coversationBody1, coversationBody2, id, _ref, _ref1;
        coversationBody1 = coversationArg1[0];
        coversationBody2 = coversationArg2[0];
        bkEventsBody = bkEventsArg != null ? bkEventsArg[0] : void 0;
        conversation = [];
        if (coversationBody1) {
          id = coversationBody1 != null ? coversationBody1.id : void 0;
          conversation = conversation.concat(coversationBody1.comments);
        }
        if (coversationBody2) {
          id = coversationBody2 != null ? coversationBody2.id : void 0;
          conversation = conversation.concat(coversationBody2.comments);
        }
        if ((bkEvents = (bkEventsBody != null ? (_ref = bkEventsBody[0]) != null ? (_ref1 = _ref.events) != null ? _ref1.full : void 0 : void 0 : void 0) || [])) {
          _this.serializeBKTransactionEvents(bkEvents);
        }
        return _this.$el.html(_.template(singleConversationTemplate, {
          attachedId: _this.attachedId,
          id: id,
          conversation: _this.formatUrls(conversation),
          timeAgo: dateFormatter.timeAgo,
          placeholderText: _this.replyPlaceholderText,
          hex_md5: md5["default"].hex_md5,
          allowedToEdit: _this.allowedToEdit,
          bkEvents: _this.bkEvents
        }));
      });
    };

    SingleConversationView.prototype.trackMessagePostedEvent = function() {
      var eventAttr, type;
      type = $(".comments-display__message").size() === 0 ? 'comment' : 'reply';
      eventAttr = {
        type: type
      };
      if (type === 'reply') {
        eventAttr.time_to_reply = Math.floor(new Date() / 1000) - $(".comments-display__footer:last").data('date');
      }
      return core.trackEvent('Message Posted', eventAttr);
    };

    SingleConversationView.prototype.postToSingleConversation = function(e) {
      var message, promise,
        _this = this;
      e.preventDefault();
      this.hideSubmit(this.$el.find(this.inputSelector));
      message = this.getText(this.$el.find(this.inputSelector));
      if (!((message != null ? message.length : void 0) > 0)) {
        return;
      }
      promise = apiCall('comments', 'single/' + this.attachedId, 'POST', {
        body: message
      }, 'json', 'x-www-form-urlencoded');
      return promise.done(function() {
        _this.trackMessagePostedEvent();
        _this.trigger('change');
        return _this.render();
      });
    };

    SingleConversationView.prototype.serializeBKTransactionEvents = function(events) {
      if (events == null) {
        events = this.bkEvents;
      }
      return this.bkEvents = events.map(function(event) {
        event.assets = _.indexBy(event.assets, function(asset) {
          return asset.payloadName || asset[asset.assetType];
        });
        return event;
      });
    };

    SingleConversationView.prototype.removeBKNotificationEvents = function() {
      var $button, promise,
        _this = this;
      $button = this.$('.comments-display__mark-as-read');
      $button.velocity('transition.slideUpOut', {
        duration: 500
      });
      promise = this.bookkeeperNotifications.removeEvents();
      promise.fail(function() {
        return _this.showNotification({
          type: 'error',
          text: 'Unable to remove transaction notifications.'
        }, $button.velocity('transition.slideDownIn', {
          duration: 100
        }));
      });
      return promise.done(function() {
        return $button.velocity('transition.slideUpOut', {
          duration: 100,
          complete: function() {
            return $button.remove();
          }
        });
      });
    };

    return SingleConversationView;

  })(Commenting);
});
